import { AlertOctagon, EyeOff, Info, MoreHorizontal, PackageX, ShieldOff } from 'lucide-react'

export type ReportReasonTone = 'red' | 'amber' | 'slate'

export type ReportReason = {
  value: string
  label: string
  sub: string
  Icon: any
  tone: ReportReasonTone
}

export const REPORT_REASONS: ReportReason[] = [
  { value: 'scam', label: 'Залилан', sub: 'Хуурамч төлбөр, мөнгө авах гэсэн оролдлого', Icon: AlertOctagon, tone: 'red' },
  { value: 'nonDelivery', label: 'Захиалга хүргэгдээгүй', sub: 'Төлбөр төлсөн боловч бараа хүлээж аваагүй', Icon: PackageX, tone: 'red' },
  { value: 'fake', label: 'Хуурамч дэлгүүр', sub: 'Бусад брэнд, хуурамч бараа худалдаалж байна', Icon: ShieldOff, tone: 'red' },
  { value: 'inappropriate', label: 'Зохисгүй контент', sub: 'Зохисгүй зураг, тайлбар, хэллэг агуулсан', Icon: EyeOff, tone: 'amber' },
  { value: 'wrongInfo', label: 'Буруу мэдээлэл', sub: 'Үнэ, бараа, нөхцөл буруу эсвэл төөрөгдүүлсэн', Icon: Info, tone: 'amber' },
  { value: 'other', label: 'Бусад', sub: 'Дээрх ангилалд орохгүй боловч маргаантай', Icon: MoreHorizontal, tone: 'slate' },
]

export const REPORT_MESSAGE_MAX = 2000

export function validateVendorReport(reason: string, message: string, contact: { name: string, phone: string, email: string }): string | null {
  if (!reason) return 'Шалтгаан сонгоно уу'
  if (message.trim().length < 5) return 'Тайлбараа дэлгэрэнгүй бичнэ үү'
  if (contact.name.trim().length < 2) return 'Нэрээ оруулна уу'
  if (!/^[0-9]{8}$/.test(contact.phone.trim())) return 'Утасны дугаар 8 оронтой байна'
  if (!/^\S+@\S+\.\S+$/.test(contact.email.trim())) return 'Имэйл хаягаа зөв оруулна уу'
  return null
}
